import settings from '../../utils/settings';
import onPlaceChanged from './_onPlaceChanged';
import getElement from './_getElement';

/**
 * Default configuration
 */
const config = {
  geolocate: false,
  onload: 'hc.initMapsApi',
  inputAddress: '#address',
  addressOnFocus: () => {
    const container = getElement('.pac-container');
    if (container) container.style['z-index'] = 1010;
  },
  onPlaceChanged,
  updateForm: null,
  apiKeyEnv: settings.isProd ? 'prod' : 'dev',
  style: {
    'font-size': '14px',
  },
};

export default config;
